"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = require("prop-types");
var _inputField = _interopRequireDefault(require("../inputField/inputField.presenter"));
var _actionButton = _interopRequireDefault(require("../actionButton/actionButton.presenter"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var EditableLabel = function EditableLabel(_ref) {
  var tooltipLabel = _ref.tooltipLabel,
    isRenaming = _ref.isRenaming,
    placeholder = _ref.placeholder,
    description = _ref.description,
    validation = _ref.validation,
    tooltipApply = _ref.tooltipApply,
    newDescription = _ref.newDescription,
    areInteractionsDisabled = _ref.areInteractionsDisabled,
    tooltipCancel = _ref.tooltipCancel,
    isPending = _ref.isPending,
    onChange = _ref.onChange,
    onKeyDown = _ref.onKeyDown,
    isSmall = _ref.isSmall,
    onStartEditing = _ref.onStartEditing,
    onApply = _ref.onApply,
    onCancel = _ref.onCancel,
    uniqueID = _ref.uniqueID;
  return _react.default.createElement("div", {
    className: "agillicEditableLabel",
    "data-testid": uniqueID
  }, isRenaming ? _react.default.createElement("div", {
    className: (0, _classnames.default)('editableLabelInput', {
      small: isSmall
    })
  }, _react.default.createElement(_inputField.default, {
    value: newDescription,
    placeholder: placeholder,
    validation: validation,
    onChange: onChange,
    onKeyDown: onKeyDown,
    isDisabled: areInteractionsDisabled,
    onStartEditing: onStartEditing,
    isSmall: isSmall,
    uniqueID: "inputField"
  }), _react.default.createElement("div", {
    className: "buttonContainer"
  }, _react.default.createElement(_actionButton.default, {
    onClick: onApply,
    icon: "check",
    isDisabled: areInteractionsDisabled,
    isPending: isPending,
    tooltip: tooltipApply,
    buttonType: "regular",
    isSmall: isSmall,
    uniqueId: "applyButton"
  }), _react.default.createElement(_actionButton.default, {
    onClick: onCancel,
    icon: "ban",
    isDisabled: areInteractionsDisabled,
    tooltip: tooltipCancel,
    buttonType: "regular",
    isSmall: isSmall,
    uniqueId: "cancelButton"
  }))) :
  // eslint-disable-next-line jsx-a11y/click-events-have-key-events
  _react.default.createElement("div", {
    className: (0, _classnames.default)('editableLabelCell', {
      small: isSmall
    }),
    onClick: onStartEditing,
    title: tooltipLabel,
    role: "button",
    tabIndex: 0
  }, _react.default.createElement("div", null, _react.default.createElement("span", null, description)), _react.default.createElement(_actionButton.default, {
    onClick: onStartEditing,
    icon: "pencil-alt",
    isDisabled: areInteractionsDisabled,
    tooltip: tooltipLabel,
    buttonType: "regular",
    isSmall: isSmall,
    "data-testid": "editButton"
  })));
};
EditableLabel.propTypes = {
  onChange: _propTypes.func.isRequired,
  onKeyDown: _propTypes.func.isRequired,
  onStartEditing: _propTypes.func.isRequired,
  onApply: _propTypes.func.isRequired,
  onCancel: _propTypes.func.isRequired,
  uniqueID: _propTypes.string.isRequired,
  validation: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    criteria: _propTypes.func.isRequired,
    message: _propTypes.string.isRequired
  })),
  tooltipLabel: _propTypes.string,
  placeholder: _propTypes.string,
  isSmall: _propTypes.bool,
  tooltipApply: _propTypes.string,
  tooltipCancel: _propTypes.string,
  isPending: _propTypes.bool,
  areInteractionsDisabled: _propTypes.bool,
  newDescription: _propTypes.string,
  description: _propTypes.string,
  isRenaming: _propTypes.bool
};
var _default = EditableLabel;
exports.default = _default;